/* vt-lightbox.js — 2026-08-11 (CC)
 *
 * `data-zoom` の付いた画像をタップ／クリックすると、全画面で大きく見られる。
 * どこを押しても閉じる。Esc でも閉じる。
 *
 * 写真は切らない：object-fit:contain で画面に収めるだけ。
 * 拡大時も srcset の大きい方を使うので、ボケない。
 */
(function () {
  var box = null, img = null;

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'vt-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    img = document.createElement('img');
    box.appendChild(img);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'vt-lb-x';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    box.appendChild(close);
    box.addEventListener('click', hide);
    document.body.appendChild(box);
  }

  function show(src, alt) {
    build();
    img.src = src;
    img.alt = alt || '';
    box.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
  }

  function hide() {
    if (!box) return;
    box.classList.remove('on');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-zoom]') : null;
    if (!t) return;
    e.preventDefault();
    // 拡大用の大きい画像があればそれを使う
    var big = t.getAttribute('data-zoom');
    show(big && big.length > 4 ? big : (t.currentSrc || t.src), t.alt);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide();
  });
})();
